import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {BottomSheet} from 'src/designSystem/components/atoms/BottomSheet/BottomSheet'
import Box from 'src/designSystem/components/atoms/Box/Box'
import PFText from 'src/designSystem/components/atoms/PFText/PFText'
import {SvgIcon} from 'src/designSystem/components/atoms/SvgIcon/SvgIcon'

export type MembershipReactivatedBottomSheetProps = {
  visible: boolean
  onDismiss: () => Promise<void>
  onCloseBottomSheet: () => Promise<void>
}

const MembershipReactivatedBottomSheet: React.FC<MembershipReactivatedBottomSheetProps> = ({
  visible,
  onDismiss: handleOnDismiss,
  onCloseBottomSheet,
}) => {
  const {t} = useTranslation(['Common', 'DashboardMembershipCanceledTile'])

  const dismissButton = useMemo(
    () => ({
      text: t('Common:Done'),
      testID: 'Membership-Reactivated-Done-Button',
    }),
    [t],
  )

  return (
    <BottomSheet
      visible={visible}
      onDismiss={handleOnDismiss}
      dismissButton={dismissButton}
      showCloseButton
      closeButtonAction={onCloseBottomSheet}
      title={<SvgIcon name={'checkWithCircle'} colorVariant={'success'} size={'enormous'} />}
      titleAlign={'left'}
      showDots={false}
      testID="Membership-Reactivated"
    >
      <Box gap="small">
        <PFText variant="h3">
          {t('DashboardMembershipCanceledTile:YourMembershipHasBeenSuccessfullyReactivated')}
        </PFText>
        <PFText variant="p">
          {t('DashboardMembershipCanceledTile:YouAreBackAndSoIsYourAccessToCashAdvances')}
        </PFText>
      </Box>
    </BottomSheet>
  )
}

export {MembershipReactivatedBottomSheet}
